import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnSubscriptionMemberBasicInfoComponent({ handleInnerFormChange, GlobalDbnRoutingPacksData, selectedDomain, parentDomain, globalDBNPRegistrationsItems }: any) {
   
    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer

                            label="SubscriptionName"
                            labelField="SubscriptionName"
                             isDisabled={!!selectedDomain?.GlobalRoutingPackSubscriptionMemberId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SubscriptionName'
                                );
                            }}
                            type="text"
                            value={selectedDomain?.SubscriptionName}
                        />
                        <div className="col-span-4">
                            <InputContainer
                                label="Subscription Description"
                                labelField="SubscriptionDescription"
                                 isDisabled={!!selectedDomain?.GlobalRoutingPackSubscriptionMemberId}
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        "SubscriptionDescription"
                                    );
                                }}
                                type="text"
                                value={selectedDomain?.SubscriptionDescription}
                            />
                        </div>
                        <InputContainer
                            label="DBNP Registrations Name"
                            labelField="DBNIEName"
                            isDisabled={!!selectedDomain?.GlobalRoutingPackSubscriptionMemberId}
                            list={globalDBNPRegistrationsItems}
                            type="select"
                            optionName="Select RegistrationsName"
                            value={selectedDomain?.MemberGlobalDBNPRegistryId || ""}
                            valueField="Id"

                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    Number(event.target.value),
                                    "MemberGlobalDBNPRegistryId"
                                );
                            }}
                        />
                    
                         <InputContainer
                            label="Routing Pack "
                            labelField="PackName"
                             isDisabled={!!selectedDomain?.GlobalRoutingPackSubscriptionMemberId}
                            list={GlobalDbnRoutingPacksData}
                            type="select"
                            optionName="Select RegistrationsName"
                            value={selectedDomain?.SubscribedPackId || ""}
                            valueField="GlobalRoutingPackId"

                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    Number(event.target.value),
                                    "GlobalRoutingPackId"
                                );
                            }}
                        />

                       
                
                    </div>
                }
                expandedPanel="userInfo"
                headerTitle="Basic Info"
            />

        </>
    )
}